import React from 'react';
import styles from './RatingsCarousel.module.scss';
import cn from 'classnames';
import ratingStar from '/img/start/rating-star.svg?url';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useTheme } from '@support/hooks/use-theme';

const reviewItems: {
  title: string;
  review: string;
}[] = [
  {
    title: 'The Best Relationship Tool Ever',
    review: `I've never seen something as magic as this tool. It is like having a personal assistant monitoring every single person you've ever met in your life`,
  },
  {
    title: "CRM you've been waiting for",
    review: `The elusive CRM has finally been solved with Clay. Unparalleled features and a product that keeps getting better.`,
  },
  {
    title: 'Phenomenal product and team!',
    review: `Truly awesome app that's stunning and easy to use and has helped me stay in touch with college friends.`,
  },
];

const CustomDot = ({ ...rest }) => {
  const { active } = rest;
  return (
    <button
      className={cn(styles.dot, {
        [styles.active]: active,
      })}
    ></button>
  );
};

export default function RatingsCarousel() {
  const [theme] = useTheme();

  return (
    <div className={styles.reviews}>
      <h3 className="heading-title">Ratings & Reviews</h3>
      <Carousel
        className={styles.carousel}
        responsive={{
          all: {
            breakpoint: { min: 0, max: 4000 },
            items: 1,
          },
        }}
        arrows={false}
        infinite={true}
        customDot={<CustomDot />}
        showDots={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        sliderClass={styles.track}
        dotListClass={styles.indicators}
      >
        {reviewItems.map((item, index) => (
          <div className={cn(styles.card, styles[theme])} key={index}>
            <div className={styles.cardTitle}>{item.title}</div>
            <div className={styles.cardStars}>
              <img className={styles.cardStar} src={ratingStar} />
              <img className={styles.cardStar} src={ratingStar} />
              <img className={styles.cardStar} src={ratingStar} />
              <img className={styles.cardStar} src={ratingStar} />
              <img className={styles.cardStar} src={ratingStar} />
            </div>
            <div className={styles.cardReview}>{item.review}</div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
